import { Component, NgModule, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ProveedoresService } from "./proveedores.service";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material";
import { Overlay } from "@angular/cdk/overlay";
import { Proveedor } from './proveedorModel';
import {MatSnackBar} from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { InicioModule } from '../inicio.module';
import { InicioService } from '../inicio/inicio.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import { catchError } from 'rxjs/operators';
import { pipe, throwError } from "rxjs";
import { Usuario } from './usuarioModel';

@NgModule({
  imports: [ReactiveFormsModule]
})

@Component({
  selector: 'app-proveedores',
  templateUrl: './proveedores.component.html',
  providers: [ProveedoresService],
  styleUrls: ['./proveedores.component.scss']
})

export class ProveedoresComponent implements OnInit {

  proveedorForm = new FormGroup({
    tipoBeneficiario: new FormControl('', [Validators.required]),
    tipoCatBenef:new FormControl('', [Validators.required]),
    tipoPersona: new FormControl('', [Validators.required]),
    tipoCategTrib: new FormControl(),
    tipoDocumento: new FormControl('', [Validators.required]),
    nroDocumento: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    nombreApellido: new FormControl('', [Validators.required]),
    nombreFantasia: new FormControl(),
    nombreCheque: new FormControl('', [Validators.required]),
    sitioInternet: new FormControl(),
    codAnterior: new FormControl(),
    critico: new FormControl(),
    fechaInicioAct: new FormControl('', [Validators.required]),
    calleFiscal: new FormControl('', [Validators.required]),
    nroCasaFiscal: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    dptoFiscal: new FormControl(),
    pisoFiscal: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    barrioFiscal: new FormControl('', [Validators.required]),
    ciudadFiscal: new FormControl('', [Validators.required]),
    codPostalFiscal: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    provinciaFiscal: new FormControl('', [Validators.required]),
    dptoProvincialFiscal: new FormControl('', [Validators.required]),
    telefonoFiscal: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(30)]),
    celularFiscal: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(30)]),
    nroLocalFiscal: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    emailFiscal: new FormControl('', [Validators.email]),
    calleReal: new FormControl('', [Validators.required]),
    nroCasaReal: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    dptoReal: new FormControl(),
    pisoReal: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    barrioReal: new FormControl('', [Validators.required]),
    ciudadReal: new FormControl('', [Validators.required]),
    codPostalReal: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    provinciaReal: new FormControl('', [Validators.required]),
    dptoProvincialReal: new FormControl('', [Validators.required]),
    telefonoReal: new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.maxLength(30)]),
    celularReal: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(30)]),
    calleEspecial: new FormControl(),
    pisoEspecial: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    barrioEspecial: new FormControl(),
    codPostalEspecial: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    nroEspecial: new FormControl('', [Validators.pattern("^[0-9]*$"), Validators.maxLength(15)]),
    dptoEspecial: new FormControl(),
    ciudadEspecial: new FormControl(),
    nombreApellidoComunicaciones: new FormControl(),
    emailComunicaciones: new FormControl('', [Validators.email]),
    cargoComunicaciones: new FormControl(),
    archivo1 : new FormControl(''),
    archivo1Nombre : new FormControl(''),
    archivo2 : new FormControl(''),
    archivo2Nombre : new FormControl('')
  })

  tiposPersona = [];
  tiposCatTrib = [];
  tiposDocumento = [];
  critico = [];
  rubros = [];
  provincias = [];
  departamentos1 = [];
  departamentos2 = [];
  tiposBeneficiario=[];
  tiposBeneficiarioCat=[];
  tipoBenefSelect: number;
  provinciaSelect1: number;
  provinciaSelect2: number;
  resultado;
  resultadoAfip;
  validadoPorAfip;
  cuitAfip;
  token;
  cargando;
  error;
  tokenValidacion;
  esEmpleado=false;
  status: boolean = false;
  tokenValidacionddjj;

  constructor(
    private service: ProveedoresService,
    private serviceInicio: InicioService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
  }

  volver(){
    this.router.navigate([`${""}`]);
  }

  ngOnInit() {
    this.critico = ['Sí', 'No'];
    this.service.getTiposPersona().subscribe(data => { this.tiposPersona = data; });
    this.service.getTiposDocumento().subscribe(data => { this.tiposDocumento = data; });
    this.service.getRubros().subscribe(data => { this.rubros = data; });
    this.service.getProvincias().subscribe(data => { this.provincias = data; });
    this.service.getTiposBenef().subscribe(data => { this.tiposBeneficiario = data });
    this.cargando = false;
    this.validadoPorAfip = false;

    this.token = sessionStorage.getItem("cidi");
    if(this.token != ''){
      this.serviceInicio.getCuitCidi(this.token,2372).subscribe(data =>{
        this.service.obtenerUsuario(data.CUIL).subscribe(response =>{
            let user = new Usuario();
            user.nombreUsuario = response.NOMBRE_USUARIO;
            user.contrasena = response.CONTRASENA;
            this.service.obtenerToken(user).subscribe(data => {
            this.tokenValidacion = data.token;
            if(data.usuario.persona.empleadoMuni =="1"){
              this.esEmpleado = true;
            }
            });

          
        });
      });
    }

  }

 

 esNumero(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
}

validarCuit() {
  this.cargando = true;
  if (this.cuitAfip != null) {
      this.service.verificarProveedor(this.cuitAfip).pipe(catchError(err => {
        this.openSnackBar(err.error.ExceptionMessage, 'Ok');
        this.cargando = false;
        return throwError('');
    })).subscribe(data => {
        this.resultadoAfip = data;
        if (this.resultadoAfip) {
          if (this.resultadoAfip.errorConstanciaField) {
            this.openSnackBar(this.resultadoAfip.errorConstanciaField.errorField[0], 'Ok');
            this.cargando = false;
            return;
          }
          this.validadoPorAfip = true;
          var datosGenerales = this.resultadoAfip.datosGeneralesField;
          var domicilioFiscal = this.resultadoAfip.datosGeneralesField.domicilioFiscalField;

          if (domicilioFiscal.codPostalField) {
            this.proveedorForm.get('codPostalFiscal').setValue(domicilioFiscal.codPostalField);
            this.proveedorForm.get('codPostalFiscal').disable({ onlySelf: true });
          }
          if (domicilioFiscal.direccionField) {
            this.proveedorForm.get('calleFiscal').setValue(domicilioFiscal.direccionField);
            this.proveedorForm.get('calleFiscal').disable({ onlySelf: true });
          }
          if (domicilioFiscal.barrioFiscal) {
            this.proveedorForm.get('barrioFiscal').setValue(domicilioFiscal.localidadField);
            this.proveedorForm.get('barrioFiscal').disable({ onlySelf: true });
          }
          if (datosGenerales.razonSocialField) {
            this.proveedorForm.get('nombreFantasia').setValue(datosGenerales.razonSocialField);
            this.proveedorForm.get('nombreFantasia').disable({ onlySelf: true });
          }
          if (datosGenerales.idPersonaField) {
            this.proveedorForm.get('nroDocumento').setValue(datosGenerales.idPersonaField);
            this.proveedorForm.get('nroDocumento').disable({ onlySelf: true });
          }
          this.cargando = false;
        }
      });
  }
  else {
    this.validadoPorAfip = false;
    this.openSnackBar('Por favor ingrese su CUIT', 'Cerrar');
    this.cargando = false;
  }
}

  // No se encuentran datos en el registro de la AFIP
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action);
  }

  OnSubmit() {
    if (this.proveedorForm.valid){
    this.addProveedor();
  }
    else
    this.openSnackBar('Todavía hay campos obligatorios por Completar','Aceptar')
  }

  cargarCategoriasBenefPago() {
    if (this.tipoBenefSelect != null)
      this.service.cargarCatBenef(this.tipoBenefSelect).subscribe(data => { this.tiposBeneficiarioCat = data })
  }

  cargarDepartamentosSelect1() {
    if (this.provinciaSelect1 != null)
      this.service.cargarDepartamentos(this.provinciaSelect1).subscribe(data => { this.departamentos1 = data })
  }

  cargarDepartamentosSelect2() {
    if (this.provinciaSelect2 != null)
      this.service.cargarDepartamentos(this.provinciaSelect2).subscribe(data => { this.departamentos2 = data })
  }

  copiarFiscal() {
    this.proveedorForm.get('calleReal').setValue(this.proveedorForm.get('calleFiscal').value);
    this.proveedorForm.get('nroCasaReal').setValue(this.proveedorForm.get('nroCasaFiscal').value);
    this.proveedorForm.get('dptoReal').setValue(this.proveedorForm.get('dptoFiscal').value);
    this.proveedorForm.get('pisoReal').setValue(this.proveedorForm.get('pisoFiscal').value);
    this.proveedorForm.get('barrioReal').setValue(this.proveedorForm.get('barrioFiscal').value);
    this.proveedorForm.get('ciudadReal').setValue(this.proveedorForm.get('ciudadFiscal').value);
    this.proveedorForm.get('codPostalReal').setValue(this.proveedorForm.get('codPostalFiscal').value);
    if (this.proveedorForm.get('provinciaFiscal').value != null) {
      this.proveedorForm.get('provinciaReal').setValue(this.proveedorForm.get('provinciaFiscal').value);
      this.proveedorForm.get('dptoProvincialReal').setValue(this.proveedorForm.get('dptoProvincialFiscal').value);
    }
    this.proveedorForm.get('telefonoReal').setValue(this.proveedorForm.get('telefonoFiscal').value);
    this.proveedorForm.get('celularReal').setValue(this.proveedorForm.get('celularFiscal').value);
  }

  resetearForm() {
    this.proveedorForm.reset();
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onFileChange(event) {

    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.proveedorForm.patchValue({
          archivo1: (reader.result as string).substring((reader.result as string).indexOf( ',' ) + 1 ),
          archivo1Nombre: file.name
        });
      }
    }
  }

  onFileChange2(event) {

    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.proveedorForm.patchValue({
          archivo2: (reader.result as string).substring((reader.result as string).indexOf( ',' ) + 1 ),
          archivo2Nombre: file.name
        });
      }
    }
  }
  inicio(){
    this.router.navigate([`${""}`]);
  }

  ddjj(): void {

    //var url = 'https://www.sigemyt.com/ingresosmlc/Inicio.aspx?atoken=' + this.tokenValidacion;
    var url =`${environment.urlddjj}?atoken=` + this.tokenValidacion;
    window.location.href=url;
  }
  miPersona(){
    //var url ='http://52.55.216.103/milegajo/Bienvenida.aspx' + '?token=' + this.tokenValidacion + '&idJur=' + 2372 + '&numJur=' + 2372;
    var url ='http://52.55.216.103/milegajo/';
    window.location.href = url + '?token=' + this.tokenValidacion + '&idJur=' + 2372 + '&numJur=' + 2372;
   // window.open(url);
  }

clickEvent() {
    this.status = !this.status;       
}

  addProveedor() {
    this.cargando = true;
    this.service.addProveedor(this.proveedorForm.getRawValue()).subscribe(result =>{

         this.resultado = result;
         console.log(this.proveedorForm.getRawValue());
         this.openSnackBar(this.resultado,'Cerrar');
         this.cargando = false;
    });

  }
}
